import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from 'src/app/shared/services/webapi.service';

@Component({
  selector: 'app-my-connections',
  templateUrl: './my-connections.component.html',
  styleUrls: ['./my-connections.component.scss']
})
export class MyConnectionsComponent implements OnInit,OnChanges {
  @Input() user:any;
  @Input() type='add';
  @Input() selectedPlaylist:any;
  keyword=''
  removingConnection=false;
  formSubmitting=false;
  addingToList=0;
  connections=[];
  removingFromList=0;
  inviteForm: FormGroup = this.fb.group({
    email: ['', Validators.compose([Validators.required, Validators.email])]
  });

  constructor(private fb: FormBuilder,public webApi: WebapiService, public router: Router, private toastrService: ToastrService) {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (propName == "selectedPlaylist" && this.user) {
        this.connections = this.user.connections
      }
    }
    // changes.prop contains the old and the new value...
  }


  ngOnInit(){
    if(this.user){
      this.connections = this.user.connections
    }
  }

  updateOnlyOnBlur(event) {
    this.connections = [];
    let filterConnections = this.user.connections.filter((item)=> { 
      return (item.connection_email.toLowerCase().indexOf(this.keyword) >= 0) 
    })
    this.connections = filterConnections;
  }

  removeConnection(connection_id){
    if (!this.removingConnection) {
      this.removingConnection = connection_id
      let params= {
        "connection_id":connection_id
      }
      this.webApi.removeConnection(params).subscribe((data: any) => {
        if(data.success){
          this.user.connections = this.connections.filter((item)=>{return item.connection_id != connection_id})
          this.toastrService.success(data.message);
        }else{
          this.toastrService.error(data.message);
        }
        this.removingConnection=false
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.removingConnection=false;
      });
    }
  }

  onSubmit(form: FormGroup) {
    if (form.valid && !this.formSubmitting) {
      this.formSubmitting=true;
      this.webApi.inviteCoach(form.value).subscribe((data: any) => {
        if (data.success) {
          form.reset();
					this.toastrService.success(data.message);
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.formSubmitting=false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.formSubmitting=false;
      });
    } else {
      this.webApi.validateAllFields(form);
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.inviteForm.controls;
  }

  checkInSharedConnections(playlistid,connection){
    if(connection?.shared?.length){
      let found = connection?.shared.filter((item1)=>{ 
        return item1.favourite_list_id==playlistid
      })
      
      return found.length>0?true:false
    }
    return false;
  }

  shareToConnection(playlist,connection,type="add") {
      this.addingToList=connection.connection_user_id;
      this.removingFromList=connection.connection_user_id
      let params = {'playlist_id':playlist,'connection_id':connection.connection_user_id};
      this.webApi.shareToConnection(params).subscribe((data: any) => {
        if (data.success) {
          if(!connection?.shared) connection.shared=[];
          if(type=="add"){
            connection.shared.push({"favourite_list_id":playlist})
          }else{
            connection.shared=connection.shared.filter((item)=>{ return item.favourite_list_id!=playlist})
          }
					this.toastrService.success(data.message);
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.removingFromList=0;
        this.addingToList=0;
      },
      error => {
        this.toastrService.error("unable to handle response");
      });
  }

}
